/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import styled from 'styled-components';

import { colors } from '@theme/index';

interface IWizardColumnsSelectionListStyled {
    isCollapse?: boolean;
}

interface IWizardColumnsSelectionItemStyled {
    isCollapse?: boolean;
}

export const WizardColumnsSelectionListStyled = styled.ul<IWizardColumnsSelectionListStyled>`
    padding-left: ${(props) => (props.isCollapse ? '32px' : 0)};
    list-style: none;
    display: flex;
    flex-direction: column;
`;

export const WizardColumnsSelectionItemStyled = styled.li<IWizardColumnsSelectionItemStyled>`
    color: ${(props) => (props.isCollapse ? colors.linkDefaultColor : colors.ColorGrey1)};
    font-weight: ${(props) => (props.isCollapse ? '700' : '400')};
    width: fit-content;
    display: flex;
    align-items: center;
    margin: ${(props) => (props.isCollapse ? '12px 0 16px' : '3px 0 5px')};

    .block-with-icon {
        display: inline-flex;
    }
`;

export const WizardColumnsSelectionItemTitleStyled = styled.p`
    margin: 0;
`;
